import { Link } from "react-router-dom";
import { Camera } from "lucide-react";
import { track } from "@/lib/track";

export const Header = () => {
  return (
    <header className="sticky top-0 z-40 border-b bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="header-logo-link" className="flex items-center gap-2 font-heading font-semibold text-lg">
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-primary-foreground">
            <Camera className="h-4 w-4" />
          </span>
          <span>KleinanzeigenGenerator</span>
        </Link>
        <nav className="flex items-center gap-4 text-sm">
          <Link to="/#kategorien" data-testid="header-nav-categories-link" className="text-muted-foreground hover:text-foreground transition-colors">Kategorien</Link>
          <Link to="/datenschutz" data-testid="header-nav-datenschutz-link" className="text-muted-foreground hover:text-foreground transition-colors hidden sm:inline">Datenschutz</Link>
          <Link to="/impressum" data-testid="header-nav-impressum-link" className="text-muted-foreground hover:text-foreground transition-colors hidden sm:inline">Impressum</Link>
        </nav>
      </div>
    </header>
  );
};

export const Footer = () => {
  return (
    <footer className="border-t bg-background mt-16">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="font-heading font-semibold">KleinanzeigenGenerator</div>
          <nav className="flex flex-wrap gap-4 text-sm text-muted-foreground">
            <Link to="/kleinanzeigen-text-aus-foto" className="hover:text-foreground">Generator</Link>
            <Link to="/datenschutz" data-testid="footer-datenschutz-link" className="hover:text-foreground">Datenschutz</Link>
            <Link to="/impressum" data-testid="footer-impressum-link" className="hover:text-foreground">Impressum</Link>
          </nav>
        </div>
        <p className="mt-6 text-xs text-muted-foreground max-w-2xl">
          Bitte gib keine sensiblen personenbezogenen Daten ein. Die Fotos und Angaben werden nur zur
          Erstellung des Verkaufstextes verwendet und nicht dauerhaft gespeichert.
        </p>
        <div className="mt-8 pt-6 border-t">
          <p className="text-xs font-medium text-muted-foreground mb-3">Weitere praktische Tools</p>
          <div className="flex flex-wrap gap-x-4 gap-y-2 text-xs text-muted-foreground">
            <a href="https://passt-das-durch.de" className="hover:text-foreground transition-colors" onClick={() => track("crosslink_click", { target: "passt-das-durch" })}>Passt das Möbel durch?</a>
            <a href="https://xn--gertekosten-n8a.de" className="hover:text-foreground transition-colors" onClick={() => track("crosslink_click", { target: "geratekosten" })}>Stromkosten je Gerät</a>
            <a href="https://bohrpunkte.de" className="hover:text-foreground transition-colors" onClick={() => track("crosslink_click", { target: "bohrpunkte" })}>Bilder gerade aufhängen</a>
            <a href="https://regalabstand.de" className="hover:text-foreground transition-colors" onClick={() => track("crosslink_click", { target: "regalabstand" })}>Regalböden berechnen</a>
            <a href="https://rechnerkiste.de" className="hover:text-foreground transition-colors" onClick={() => track("crosslink_click", { target: "rechnerkiste" })}>Mehr aus der Rechnerkiste</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
